import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from '../auth';
import { Shell } from './Shell';
import { SignIn } from '../screens/SignIn';
import { Home } from '../screens/Home';
import { Catalog } from '../screens/Catalog';
import { ModulePage } from '../screens/ModulePage';
import { Settings } from '../screens/Settings';
import { ManageModules } from '../screens/ManageModules';
import { ModuleRoute } from '../screens/ModuleRoute';
import { NotFound } from '../screens/NotFound';
import { Join } from '../screens/Join';
import { Team } from '../screens/Team';
import { Guide } from '../screens/Guide';
import { FollowUpsScreen } from '../screens/FollowUps';
import { Contacts } from '../screens/Contacts';
import { AlertsScreen } from '../screens/Alerts';
import { Company } from '../screens/Company';
import { JobHome } from '../screens/JobHome';
import { CompanyHome } from '../screens/CompanyHome';
import { Toaster } from './toast';
import { LocationGate, useLocationGate } from './LocationGate';
import { listModules } from '@tradeview/core';

/** An invite link (/join?code=PP-…, or v1's ?invite=PP-… on any path) lands before sign-in. */
function inviteCode(): string | null {
  const u = new URL(window.location.href);
  if (u.pathname === '/join') return u.searchParams.get('code') ?? '';
  return u.searchParams.get('invite');
}

export function App() {
  const { loading, session, error } = useAuth();
  const gate = useLocationGate(session);
  if (loading) return <Splash />;
  if (!session) { const code = inviteCode(); return <>{code !== null ? <Join code={code} /> : <SignIn error={error} />}<Toaster /></>; }
  if (window.location.pathname === '/join') window.history.replaceState(null, '', '/');
  if (gate.state !== 'ok') return <><LocationGate state={gate.state} onAsk={gate.ask} /><Toaster /></>;
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/modules" element={<Catalog />} />
        <Route path="/modules/:id" element={<ModulePage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/settings/modules" element={<ManageModules />} />
        <Route path="/settings/team" element={<Team />} />
        <Route path="/settings/followups" element={<FollowUpsScreen />} />
        <Route path="/settings/contacts" element={<Contacts />} />
        <Route path="/alerts" element={<AlertsScreen />} />
        <Route path="/settings/company" element={<Company />} />
        <Route path="/job/:id" element={<JobHome />} />
        <Route path="/company" element={<CompanyHome />} />
        <Route path="/join" element={<Navigate to="/" replace />} />
        {listModules().flatMap(m => m.manifest.routes.map(r => (
          <Route key={`${m.manifest.id}${r.path}`} path={r.path} element={<ModuleRoute moduleId={m.manifest.id} screen={r.screen} roles={r.roles} />} />
        )))}
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </Shell>
  );
}

function Splash() {
  return (
    <div className="min-h-full grid place-items-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-16 h-16 rounded-[18px] bg-accent text-accent-ink grid place-items-center font-disp font-bold text-4xl">T</div>
        <div className="skel w-24 h-3" />
      </div>
    </div>
  );
}
